.biel-search-header-container {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--biel-header-border-color);
  margin-bottom: 10px;
  padding-bottom: 10px;
}

biel-search-input {
  flex-grow: 1;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-left: 12px;
}

.close-button svg {
  width: 20px;
  height: 20px;
  color: var(--biel-search-content-text-color);
}

.biel-search-header__filters-container {
  overflow-x: auto;
  margin-bottom: 6px;
}

.biel-search-header__filters-container::-webkit-scrollbar {
  height: 0;
}

@media screen and (min-width: 768px) {
  .biel-search-header__filters-container::-webkit-scrollbar {
    height: 6px;
  }

  .biel-search-header__filters-container::-webkit-scrollbar-thumb {
    background-color: var(--biel-chat-scrollbar-color);
    border-radius: 10px;
    border: 1px solid transparent;
  }

  .biel-search-header__filters-container::-webkit-scrollbar-thumb:hover {
    background-color: var(--biel-chat-scrollbar-hover-color);
  }
}